module.exports = function() {
  return new Worker(__webpack_public_path__ + "580762030c50192bfa71.worker.js");
};